import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Footer from "../Common-components/Footer/Footer";
import Header from "../Common-components/Header/Header";
import RegionAndLanguage from "../components/views/LandingPage";
import {
  selectBatsVersion,
  selectCountryCode,
  selectIsSignIn,
  selectLanguage,
} from "../redux-toolkit/authReducer";
import { AuthService } from "../services/AuthService";
import ScrollToTop from "../utils/ScrollToTop";
import NotFoundRouter from "./NotFoundRouter";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
// import { applicationRouters } from "./router.config";
import { applicationRouters } from "./bats.router.config";
import SignInCallback from "../scenes/SignInCallback";
import SignOutCallback from "../scenes/SignOutCallback";
import EditProfileCallback from "../scenes/EditProfileCallback";
import { Region } from "../models/RegionState";
import LaunchLinkRedirect from "../components/views/LaunchLinkRedirect";
import SSOPage from "../components/views/sso/SSOPage";
import { RouteConfigure } from "../models/Route";
import AppWrapper from "../layout/appWrapper/AppWrapper";
import CustomLoader from "../Common-components/loading/CustomLoader";
import { BATSVersion } from "../models/pageConfiguration/BATSVersion";
import "./index.scss";
import { useTranslation } from "@localization/contexts/i18nContext";
import { selectAccount } from "../redux-toolkit/accountReducer";

interface IBatsRouter {
  regions: Region[];
}

const Router: React.FC<IBatsRouter> = ({ regions }) => {
  const authService = AuthService.getInstance();
  const isSignIn = useSelector(selectIsSignIn);
  const countryCode = useSelector(selectCountryCode);
  const currentAccount = useSelector(selectAccount);
  const auth = AuthService.getAuthState();
  useEffect(() => { }, [isSignIn]);
  useEffect(() => { }, [countryCode]);
  const { changeLanguage, currentLcid } = useTranslation();
  const batsVersion = useSelector(selectBatsVersion);
  const [routers, setRouters] = useState<RouteConfigure[] | null>(null);
  const [previousVirtualPage, setPreviousVirtualPage] = useState("");
  const language = useSelector(selectLanguage);
  const location = useLocation();

  useEffect(() => {
    if (window.location.href.includes("/regions")) {
      changeLanguage("en");
    } else if (currentLcid.toLowerCase() !== language.toLowerCase()) {
      changeLanguage(language);
    }
  }, [location, isSignIn, currentAccount, language]);

  useEffect(() => {
    const targetRouters = applicationRouters[batsVersion as BATSVersion];

    setRouters(
      targetRouters ? targetRouters : applicationRouters[BATSVersion.BATSv4]
    );
  }, [batsVersion]);

  if (!routers) return <CustomLoader />;

  return (
    <div>
      <ScrollToTop />
      <div className="w-screen h-screen flex justify-center p-8">
        <Switch>
          <Route path="/regions" exact component={RegionAndLanguage} />
          <Route
            path="/editprofilecallback"
            exact
            component={EditProfileCallback}
          />
          <Route path="/signincallback" exact component={SignInCallback} />
          <Route path="/signoutcallback" exact component={SignOutCallback} />
          <Route path="/sso" exact component={SSOPage} />
          <Route
            path="/launchlinkredirect"
            exact
            component={LaunchLinkRedirect}
          />
          <Route path="/de/" exact>
            <Redirect to="/" />
          </Route>

          {/* {applicationRouters.map((route: any, index: any) => (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={(routeProps) => {
                const crumbs = applicationRouters
                  .filter(({ path }) => routeProps.match.path.includes(path))
                  .map(({ path, ...rest }) => ({
                    path: path,
                    ...rest,
                  }));
                const renderRoute = route.isProtected ? (
                  <ProtectedRoute
                    key={index}
                    {...routeProps}
                    exact={route.exact}
                    isSignIn={isSignIn}
                    countryCode={countryCode}
                    domain={auth.domain}
                    component={route.component}
                    permission={route.permission}
                  />
                ) : (
                  <PublicRoute
                    key={index}
                    {...routeProps}
                    exact={route.exact}
                    countryCode={countryCode}
                    domain={auth.domain}
                    path={route.path}
                    component={route.component}
                  />
                );

                return (
                  <div className="p-8">
                    <span></span>
                    <Header crumbs={crumbs}></Header>
                    <div
                      className={`grid-responsive-width body-container ${
                        window.location.pathname === "/"
                          ? "home-page-wrapper"
                          : ""
                      } ${
                        window.location.pathname === "/checkout"
                          ? "checkout-page-wrapper"
                          : ""
                      }`}
                    >
                      {renderRoute}
                    </div>
                  </div>
                );
              }}
            />
          ))} */}
          {routers.map((route: any, index: any) => (
            <Route
              key={index} // DO NOT CHANGE THIS KEY (IGNORE SONAR QUEBE WARNING)
              path={route.path}
              exact={route.exact}
              render={(routeProps) => {
                /*   if (route.path !== previousVirtualPage) {
                    addAnalyticEvent("virtualPageview", {
                      page_path: route.path,
                      step_name: route.title,
                    });
                  } */
                setPreviousVirtualPage(route.path);

                const renderedRoute = route.isProtected ? (
                  <ProtectedRoute
                    key={index} // DO NOT CHANGE THIS KEY (IGNORE SONAR QUEBE WARNING)
                    {...routeProps}
                    exact={route.exact}
                    isSignIn={isSignIn}
                    countryCode={countryCode}
                    component={route.component}
                    permission={route.permission}
                    //role={route.role}
                    domain={auth.domain}
                  //isMapingRequired={route.isMapingRequired}
                  //isTrialHidden={route.isTrialHidden}
                  />
                ) : (
                  <PublicRoute
                    key={index} // DO NOT CHANGE THIS KEY (IGNORE SONAR QUEBE WARNING)
                    {...routeProps}
                    exact={route.exact}
                    countryCode={countryCode}
                    path={route.path}
                    domain={auth.domain}
                    component={route.component}
                  />
                );

                return <AppWrapper route={renderedRoute} />;
              }}
            />
          ))}
          <Route component={NotFoundRouter} />
        </Switch>
      </div>
      {/* {!(
        window.location.href.includes("/signincallback") ||
        window.location.href.includes("/signoutcallback") ||
        window.location.href.includes("/sso") ||
        window.location.href.includes("/editprofilecallback") ||
        window.location.href.includes("/launchlinkredirect")
      )
        // && <Footer />
      } */}
    </div>
  );
};

export default Router;
